import {Link} from "react-router-dom";

const NotFoundPage = () => {
  return (
    <div className="main-container-blk">
      <div className="not-found-page">
        <h2>Page not found</h2>
        <h1>404</h1>
        <p>
          The link you entered may be broken, or the page may have been removed.
        </p>
        <Link to="/introduction">
          Back to Home <i className="fa-solid fa-arrow-right"></i>
        </Link>
      </div>
    </div>
  );
};

export default NotFoundPage;
